<template>
    <div>

        <a class="btn inline-block" @click="modalOpen = true"><i class="fa fa-download"></i> Export Chart</a>

        <portal to="modals" v-if="modalOpen">
            <modal @close="modalOpen = false" :large="true">

                <template slot="header">Export Chart as Image</template>

                <div class="p-4">

                    <div class="">
                        Width: <input class="p-2 rounded border border-blue-dark" type="number" v-model="width">

                        Height: <input class="p-2 rounded border border-blue-dark" type="number" v-model="height">
                    </div>

                    <div class="mt-4">

                        <h2>Presets</h2>

                        <div class="flex">

                            <a class="cursor-pointer hover:bg-blue-light flex justify-center items-center h-32 w-32 block border rounded hover:border-blue-dark"
                               @click="set(1024,768)">PowerPoint</a>

                            <a class="ml-4 cursor-pointer hover:bg-blue-light flex justify-center items-center h-32 w-32 block border rounded hover:border-blue-dark"
                               @click="set(1280,720)">4:3</a>

                            <a class="ml-4 cursor-pointer hover:bg-blue-light flex justify-center items-center h-32 w-32 block border rounded hover:border-blue-dark"
                               @click="set(1920,1080)">16:9</a>

                        </div>

                    </div>

                    <div class="mt-4">
                        <a class="btn inline-block" @click="exportChart('image/svg+xml')">
                            <i class="fa fa-download"></i> SVG
                        </a>
                        <a class="btn inline-block" @click="exportChart('image/png')">
                            <i class="fa fa-download"></i> PNG
                        </a>
                    </div>

                    <div class="mt-4">
                        Preview:

                        <div class="flex justify-center">
                            <highcharts ref="exportImage" id="exportImage" :height="height" :width="width"
                                        :showExport="false" :minimize="true"></highcharts>
                        </div>

                    </div>

                </div>
            </modal>
        </portal>

    </div>
</template>

<script>
    const MAXSIZE = 4000;

    export default {
        name: "ExportImage",

        data: () => ({
            modalOpen: false,
            width: 800,
            height: 600,
        }),

        watch: {
            width(value) {
                if (value > MAXSIZE) {
                    this.width = MAXSIZE;
                }
            },
            height(value) {
                if (value > MAXSIZE) {
                    this.height = MAXSIZE;
                }
            },
        },

        methods: {
            exportChart(type) {
                this.$refs.exportImage.exportChart(type);
            },
            set(width, height) {
                this.width = width;
                this.height = height;
            },
        }
    }
</script>

<style scoped>

</style>
